import type { ThemeDefinition } from 'vuetify'
import { themeColors } from './themeColors'

export const lightTheme: ThemeDefinition = {
  colors: themeColors,
  variables: {
    'medium-emphasis-opacity': 1,
    'high-emphasis-opacity': 1,
    'snackbar-content-padding': '6px 16px',
    'shadow-key-umbra-opacity': 'rgba(29, 41, 57, 0.08)',
    'shadow-key-penumbra-opacity': 'rgba(29, 41, 57, 0.08)',
    'shadow-key-ambient-opacity': 'rgba(29, 41, 57, 0.08)'
  }
}
